import { cloneDeep } from 'lodash-es';

import {
  aboutMyselfRelationshipFamilyMemberCondition,
  aboutMyselfRelationshipVeteranCondition,
  aboutSomeoneElseRelationshipConnectedThroughWorkCondition,
  aboutSomeoneElseRelationshipConnectedThroughWorkEducationCondition,
  aboutSomeoneElseRelationshipFamilyMemberAboutFamilyMemberCondition,
  aboutSomeoneElseRelationshipFamilyMemberAboutVeteranCondition,
  aboutSomeoneElseRelationshipFamilyMemberCondition,
  aboutSomeoneElseRelationshipVeteranCondition,
  aboutSomeoneElseRelationshipVeteranOrFamilyMemberEducationCondition,
  generalQuestionCondition,
} from '../helpers';
import { ch3Pages, flowPaths } from './ch3Pages';

export const buildFlowPages = (list, path, obj = ch3Pages) => {
  const pages = cloneDeep(obj);
  const flowGroup = {};
  const flowGroupName = path.split('-').join('').toLowerCase();

  const conditionMap = {
    aboutmyselfrelationshipveteran: aboutMyselfRelationshipVeteranCondition,
    aboutmyselfrelationshipfamilymember:
      aboutMyselfRelationshipFamilyMemberCondition,
    aboutsomeoneelserelationshipveteran:
      aboutSomeoneElseRelationshipVeteranCondition,
    aboutsomeoneelserelationshipfamilymember:
      aboutSomeoneElseRelationshipFamilyMemberCondition,
    aboutsomeoneelserelationshipfamilymemberaboutveteran:
      aboutSomeoneElseRelationshipFamilyMemberAboutVeteranCondition,
    aboutsomeoneelserelationshipfamilymemberaboutfamilymember:
      aboutSomeoneElseRelationshipFamilyMemberAboutFamilyMemberCondition,
    aboutsomeoneelserelationshipconnectedthroughwork:
      aboutSomeoneElseRelationshipConnectedThroughWorkCondition,
    aboutsomeoneelserelationshipconnectedthroughworkeducation:
      aboutSomeoneElseRelationshipConnectedThroughWorkEducationCondition,
    aboutsomeoneelserelationshipveteranorfamilymembereducation:
      aboutSomeoneElseRelationshipVeteranOrFamilyMemberEducationCondition,
    generalquestion: generalQuestionCondition,
  };

  list.forEach((page, index) => {
    const key = `${page}_${flowGroupName}`;
    flowGroup[key] = pages[page];
    flowGroup[key].path = `${path}-${index + 1}`;

    // Add depends clause based on flowGroupName
    if (conditionMap[flowGroupName]) {
      const newCondition = conditionMap[flowGroupName];
      if (flowGroup[key].depends) {
        const existingCondition = flowGroup[key].depends;
        flowGroup[key].depends = formData =>
          existingCondition(formData) && newCondition(formData);
      } else {
        flowGroup[key].depends = newCondition;
      }
    }
  });
  return flowGroup;
};

export const askVaFlows = {
  aboutMyselfRelationshipVeteran: [
    'facilityInYourProfile',
    'searchSchools',
    'saveThisFacility',
    'stateOfSchool',
    'schoolStOrResidencyForDebtEduStudents',
    'yourVAHealthFacility',
    'yourVREInformation',
    'yourVRECounselor',
    'stateOfProperty',
    'yourBranchOfService',
    'yourContactInformation',
    'yourMailingAddress',
    'addressValidation',
    'yourLocationOfResidence',
    'yourPostalCode',
  ],
  aboutMyselfRelationshipFamilyMember: [
    'moreAboutYourRelationshipToVeteran',
    'aboutTheVeteran',
    'dateOfDeath',
    'facilityInYourProfile',
    'searchSchools',
    'saveThisFacility',
    'stateOfSchool',
    'schoolStOrResidencyForDebtEduStudents',
    'yourVAHealthFacility',
    'yourVREInformation',
    'yourVRECounselor',
    'stateOfProperty',
    'aboutYourselfRelationshipFamilyMember',
    'yourContactInformation',
    'yourMailingAddress',
    'addressValidation',
    'yourLocationOfResidence',
    'yourPostalCode',
  ],
  aboutSomeoneElseRelationshipVeteran: [
    'aboutYourRelationshipToFamilyMember',
    'aboutYourFamilyMember',
    'facilityInYourProfile',
    'searchSchools',
    'saveThisFacility',
    'stateOfSchool',
    'yourVAHealthFacility',
    'theirVREInformation',
    'theirVRECounselor',
    'stateOfProperty',
    'familyMembersLocationOfResidence',
    'familyMembersPostalCode',
    'aboutYourself',
    'yourBranchOfService',
    'yourContactInformation',
    'yourMailingAddress',
    'addressValidation',
  ],
  aboutSomeoneElseRelationshipFamilyMember: [
    'isQuestionAboutVeteranOrSomeoneElse',
  ],
  aboutSomeoneElseRelationshipFamilyMemberAboutVeteran: [
    'moreAboutYourRelationshipToVeteran',
    'aboutTheVeteran',
    'dateOfDeath',
    'facilityInYourProfile',
    'searchSchools',
    'saveThisFacility',
    'stateOfSchool',
    'schoolStOrResidencyForDebtEduStudents',
    'yourVAHealthFacility',
    'theirVREInformation',
    'theirVRECounselor',
    'stateOfProperty',
    'veteransLocationOfResidence',
    'veteransPostalCode',
    'aboutYourselfRelationshipFamilyMember',
    'yourContactInformation',
    'yourMailingAddress',
    'addressValidation',
  ],
  aboutSomeoneElseRelationshipFamilyMemberAboutFamilyMember: [
    'theirRelationshipToVeteran',
    'aboutTheVeteran',
    'dateOfDeath',
    'aboutYourFamilyMember',
    'facilityInYourProfile',
    'searchSchools',
    'saveThisFacility',
    'stateOfSchool',
    'schoolStOrResidencyForDebtEduStudents',
    'yourVAHealthFacility',
    'theirVREInformation',
    'theirVRECounselor',
    'stateOfProperty',
    'familyMembersLocationOfResidence',
    'familyMembersPostalCode',
    'aboutYourselfGeneral',
    'yourContactInformation',
    'yourMailingAddress',
    'addressValidation',
  ],
  aboutSomeoneElseRelationshipVeteranOrFamilyMemberEducation: [
    'schoolStOrResidency',
    'aboutYourself',
    'yourContactInformation',
  ],
  aboutSomeoneElseRelationshipConnectedThroughWork: [
    'yourRole',
    'aboutTheVeteran',
    'dateOfDeath',
    'facilityInYourProfile',
    'searchSchools',
    'saveThisFacility',
    'stateOfSchool',
    'schoolStOrResidencyForDebtEduStudents',
    'yourVAHealthFacility',
    'theirVREInformation',
    'theirVRECounselor',
    'stateOfProperty',
    'veteransLocationOfResidence',
    'veteransPostalCode',
    'aboutYourself',
    'yourContactInformation',
    'yourMailingAddress',
    'addressValidation',
  ],
  aboutSomeoneElseRelationshipConnectedThroughWorkEducation: [
    'yourRoleEducation',
    'facilityInYourProfile',
    'searchSchools',
    'saveThisFacility',
    'stateOfSchool',
    'stateOfFacility',
    'aboutYourselfGeneral',
    'yourContactInformation',
  ],
  generalQuestion: [
    'facilityInYourProfile',
    'searchSchools',
    'saveThisFacility',
    'stateOfSchool',
    'schoolStOrResidencyForDebtEduStudents',
    'yourVAHealthFacility',
    'yourVREInformation',
    'yourVRECounselor',
    'stateOfProperty',
    'aboutYourselfGeneral',
    'yourContactInformation',
    'yourMailingAddress',
    'addressValidation',
    'yourLocationOfResidence',
    'yourPostalCode',
  ],
};

export const aboutMyselfRelationshipVeteranPages = buildFlowPages(
  askVaFlows.aboutMyselfRelationshipVeteran,
  flowPaths.aboutMyselfRelationshipVeteran,
);
export const aboutMyselfRelationshipFamilyMemberPages = buildFlowPages(
  askVaFlows.aboutMyselfRelationshipFamilyMember,
  flowPaths.aboutMyselfRelationshipFamilyMember,
);
export const aboutSomeoneElseRelationshipVeteranPages = buildFlowPages(
  askVaFlows.aboutSomeoneElseRelationshipVeteran,
  flowPaths.aboutSomeoneElseRelationshipVeteran,
);
export const aboutSomeoneElseRelationshipFamilyMemberPages = buildFlowPages(
  askVaFlows.aboutSomeoneElseRelationshipFamilyMember,
  flowPaths.aboutSomeoneElseRelationshipFamilyMember,
);
export const aboutSomeoneElseRelationshipFamilyMemberAboutVeteranPages =
  buildFlowPages(
    askVaFlows.aboutSomeoneElseRelationshipFamilyMemberAboutVeteran,
    flowPaths.aboutSomeoneElseRelationshipFamilyMemberAboutVeteran,
  );
export const aboutSomeoneElseRelationshipFamilyMemberAboutFamilyMemberPages =
  buildFlowPages(
    askVaFlows.aboutSomeoneElseRelationshipFamilyMemberAboutFamilyMember,
    flowPaths.aboutSomeoneElseRelationshipFamilyMemberAboutFamilyMember,
  );
export const aboutSomeoneElseRelationshipVeteranOrFamilyMemberEducationPages =
  buildFlowPages(
    askVaFlows.aboutSomeoneElseRelationshipVeteranOrFamilyMemberEducation,
    flowPaths.aboutSomeoneElseRelationshipVeteranOrFamilyMemberEducation,
  );
export const aboutSomeoneElseRelationshipConnectedThroughWorkPages =
  buildFlowPages(
    askVaFlows.aboutSomeoneElseRelationshipConnectedThroughWork,
    flowPaths.aboutSomeoneElseRelationshipConnectedThroughWork,
  );
export const aboutSomeoneElseRelationshipConnectedThroughWorkEducationPages =
  buildFlowPages(
    askVaFlows.aboutSomeoneElseRelationshipConnectedThroughWorkEducation,
    flowPaths.aboutSomeoneElseRelationshipConnectedThroughWorkEducation,
  );
export const generalQuestionPages = buildFlowPages(
  askVaFlows.generalQuestion,
  flowPaths.general,
);
